import React, { useEffect } from 'react'
import { useLocation } from '../../../../context/LocationContext';

export interface FormProps {
  val: any
}

export default function Form({ val }: FormProps) {

  const location = useLocation();
  const state = location?.state as any;

  return (
    <div>
      Form {val}

      {state.email && <div>Email: {state.email}</div>}

    </div>
  )
}
